import { render } from "./FeedbackTable.vue?vue&type=template&id=1e776775"
import script from "./FeedbackTable.vue?vue&type=script&lang=js"
export * from "./FeedbackTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__